var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Dimmer, Form, Input, Loader, Message } from "semantic-ui-react";
import ErrorDisplay from "../ErrorDisplay";
import { postWithAuthn } from "../RequestHelpers";
var UploadCommentAttachmentsModal = /** @class */ (function (_super) {
    __extends(UploadCommentAttachmentsModal, _super);
    function UploadCommentAttachmentsModal(props) {
        var _this = _super.call(this, props) || this;
        _this.addAttachment = function (event, _) {
            var list = event.currentTarget.files;
            if (list === null || list.length === 0) {
                return;
            }
            var attachmentFiles = Array.from(list);
            _this.setState(function (prevState) {
                return {
                    attachments: prevState.attachments.concat(attachmentFiles)
                };
            });
        };
        _this.removeAttachment = function (fileName) {
            return function () {
                _this.setState(function (prevState) {
                    return {
                        attachments: prevState.attachments.filter(function (a) { return a.name !== fileName; })
                    };
                });
            };
        };
        _this.submit = function () {
            _this.setState({
                loading: true,
                success: false,
            }, function () {
                var formData = new FormData();
                _this.state.attachments.forEach(function (p, index) {
                    formData.append("attachment-" + index, p);
                });
                postWithAuthn("/admin/orders/id/" + encodeURIComponent(_this.props.orderId) + "/events/id/" + encodeURIComponent(_this.props.eventId) + "/upload-comment-attachment", formData)
                    .then(function (resp) {
                    if (resp.ok) {
                        _this.setState({
                            loading: false,
                            success: true,
                            errors: [],
                            attachments: []
                        });
                        return;
                    }
                    else {
                        _this.setState({
                            loading: false,
                            success: false,
                            errors: [{
                                    path: '/',
                                    msg: 'An unexpected error occurred'
                                }]
                        });
                        return;
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't Add Attachments: " + rej);
                });
            });
        };
        _this.state = {
            loading: false,
            success: false,
            errors: [],
            attachments: []
        };
        return _this;
    }
    UploadCommentAttachmentsModal.prototype.render = function () {
        var _this = this;
        return React.createElement(Dimmer.Dimmable, { as: Form, error: this.state.errors.length > 0 },
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            this.state.attachments.length,
            " Attachments selected",
            this.state.attachments.map(function (f, index) {
                return React.createElement("div", { key: index },
                    "Attachment #",
                    index + 1,
                    ": ",
                    f.name,
                    " ",
                    React.createElement(Button, { icon: "x", color: 'red', size: 'mini', onClick: _this.removeAttachment(f.name) }));
            }),
            React.createElement("div", null,
                React.createElement(Input, { type: 'file', onChange: this.addAttachment, multiple: true })),
            this.state.success &&
                React.createElement(Message, { positive: true }, "Attachments uploaded."),
            React.createElement(ErrorDisplay, { errors: this.state.errors, errorPath: '/' }),
            React.createElement("br", null),
            React.createElement(Button, { disabled: this.state.success || this.state.attachments.length === 0, icon: 'upload', label: 'Add Attachments', labelPosition: 'left', onClick: this.submit, positive: true }));
    };
    return UploadCommentAttachmentsModal;
}(React.PureComponent));
export default UploadCommentAttachmentsModal;
;
//# sourceMappingURL=UploadCommentAttachment.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/UploadCommentAttachment.js
// module id = 1197
// module chunks = 0